var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9.5C17 13.9183 13.4183 17.5 9 17.5C4.58172 17.5 1 13.9183 1 9.5C1 5.08172 4.58172 1.5 9 1.5C13.4183 1.5 17 5.08172 17 9.5ZM18 9.5C18 14.4706 13.9706 18.5 9 18.5C4.02944 18.5 0 14.4706 0 9.5C0 4.52944 4.02944 0.5 9 0.5C13.9706 0.5 18 4.52944 18 9.5ZM9.97349 15.125V7.04529H8.02837V15.125H9.97349ZM10.1625 5.16316C10.2307 5.01616 10.2649 4.85866 10.2649 4.69066C10.2649 4.51741 10.2307 4.35466 10.1625 4.20241C10.0942 4.05016 10.0024 3.91891 9.88687 3.80866C9.77662 3.69841 9.64537 3.61179 9.49312 3.54879C9.34087 3.48054 9.17812 3.44641 9.00487 3.44641C8.83687 3.44641 8.67674 3.48054 8.52449 3.54879C8.37749 3.61179 8.24887 3.69841 8.13862 3.80866C8.02837 3.91891 7.93912 4.05016 7.87087 4.20241C7.80787 4.35466 7.77637 4.51741 7.77637 4.69066C7.77637 4.85866 7.80787 5.01616 7.87087 5.16316C7.93912 5.31016 8.02837 5.43879 8.13862 5.54904C8.24887 5.65929 8.37749 5.74854 8.52449 5.81679C8.67674 5.87979 8.83687 5.91129 9.00487 5.91129C9.17812 5.91129 9.34087 5.87979 9.49312 5.81679C9.64537 5.74854 9.77662 5.65929 9.88687 5.54904C10.0024 5.43879 10.0942 5.31016 10.1625 5.16316Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleIconOutline);
export default __webpack_public_path__ + "static/media/info-circle-icon-outline.83038808b8989aab0132772422a380b2.svg";
export { ForwardRef as ReactComponent };